/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2021
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

export function updateFiltersAction(payload) {
  return {
    type: ActionTypes.UPDATE_FILTERS,
    payload,
  };
}
